export default {
  fetching: true,
  error: null,
  projects: [],
  filters: {
    title: "",
    page: "1",
    ward: "",
    status: "",
    sort_by: "",
    type: "",
  },
  pagination: {
    total: null,
    start_index: null,
    current_page: null,
    per_page: null,
    total_pages: null,
    count: null,
    links: null,
  },
};



// WEBPACK FOOTER //
// ./src/infraMonitor/localInitialState.js